import { PaymentHistoryResultType, PaymentHistoryType } from '../../app/modules/types/paymentHistory'
import { apiClient } from '../client'
import { InvoiceResponse, InvoiceType } from '../../app/modules/types/paymentInvoices'

export interface PaymentHistoryResponse {
  results: PaymentHistoryType[]
  total_pages: number
  current_page: number
  count: number
}

/**
 * Payments API endpoints
 */
export const paymentsApi = {
  /**
   * Get payment history list (paginated)
   */
  getHistory: async (params?: string): Promise<PaymentHistoryResponse> => {
    const url = params ? `/payments/?${params}` : '/payments/'
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get payment details by ID
   */
  getPaymentDetail: async (paymentId: string): Promise<PaymentHistoryResultType> => {
    const { data } = await apiClient.get(`/payments/${paymentId}/`)
    return data
  },

  /**
   * Get invoice list
   */
  getInvoices: async (params?: string): Promise<InvoiceResponse> => {
    const url = params ? `/invoices/?${params}` : '/invoices/'
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get invoice details by ID
   */
  getInvoiceDetail: async (invoiceId: string): Promise<InvoiceType> => {
    const { data } = await apiClient.get(`/invoices/${invoiceId}/`)
    return data
  },

  /**
   * Initiate subscription payment
   */
  paySubscription: async (payload: any): Promise<{ payment_url: string }> => {
    const { data } = await apiClient.post('/subscription/pay/', payload)
    return data
  },

  /**
   * Verify subscription payment
   */
  verifySubscription: async (authority: string, status: string): Promise<any> => {
    const { data } = await apiClient.post('/subscription/verify/', { authority, status })
    return data
  },
}
